export { Avatar } from '@mantine/core'